import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/global.css'
import VCharts from 'v-charts'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Fingerprint2 from 'fingerprintjs2'
import Mygv from './plugins/mygv.js'
import Print from 'vue-print-nb'

Vue.use(VueAxios, axios)
Vue.use(VCharts)
Vue.use(Print)
Vue.config.productionTip = false
Vue.prototype.global = Mygv

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Event = new Vue()

// //获取浏览器指纹信息
// if (window.requestIdleCallback) {
//    requestIdleCallback(function () {
//     Fingerprint2.get(function (components) {
//       var values = components.map(function (component) { return component.value })
//       var murmur = Fingerprint2.x64hash128(values.join(''), 31)
//       Vue.prototype.global.LocalFingerprint = murmur
//       localStorage.setItem('LocalFingerprint', murmur)
//     })
//   })
// } else {
//   setTimeout(function () {
//    Fingerprint2.get(function (components) {
//       var values = components.map(function (component) { return component.value })
//       var murmur = Fingerprint2.x64hash128(values.join(''), 31)
//       Vue.prototype.global.LocalFingerprint = murmur
//       localStorage.setItem('LocalFingerprint', murmur)
//     })
//   }, 500)
// }
